import styled from 'styled-components';
import {dFlex, flexColumn, alignStart} from '../../../../../../globalVariables/GlobalFlex';
import {getToken, getSpacing, getFontSize, getFontWeight, responsive} from '@tickchak/react-share/app';
import { section } from '../PricingStep/PricingStep.css';


export const timeLineSection = styled(section)`
    background: transparent;
`;
export const validityHeader = styled.div`
    ${dFlex};
    ${flexColumn};
    ${alignStart};
    gap: ${getSpacing('spaceSm')};
    width: 100%;
`;

export const validityTitle = styled.h2`
    ${responsive(getFontSize('bodySmall'), 'font-size')};
    ${responsive(getFontWeight('bold'), 'font-weight')};
    color: ${getToken('color.text.primary')};
    margin: 0;
`;

export const lifecycleSubtitle = styled.div`
    ${responsive(getFontSize('caption'), 'font-size')};
    color: ${getToken('color.text.primary')};
`;

